const translation = {
  toVerifiedTip: {
    coupon: 'cupom exclusiv 100%',
    front: 'Sunteți acum eligibil pentru statutul de Educație Verificată. Vă rugăm să introduceți informațiile despre educația dumneavoastră mai jos pentru a finaliza procesul și a primi un',
    end: 'pentru Planul Profesional Dify.',
  },
  form: {
    schoolName: {
      placeholder: 'Introduceți numele oficial, neabbreviat al școlii dumneavoastră',
      title: 'Numele Școlii Tale',
    },
    schoolRole: {
      option: {
        teacher: 'Profesor',
        administrator: 'Administrator școlar',
        student: 'Student',
      },
      title: 'Rolul tău la școală',
    },
    terms: {
      desc: {
        and: 'și',
        front: 'Informațiile tale și utilizarea statutului de Educație Verificată sunt supuse termenilor noștri',
        end: 'Prin trimiterea:',
        termsOfService: 'Termeni și condiții',
        privacyPolicy: 'Politica de confidenţialitate',
      },
      option: {
        inSchool: 'Confirm că sunt înscris sau angajat la instituția menționată. Dify poate solicita dovada înscrierii/angajării. Dacă îmi reprezint greșit eligibilitatea, sunt de acord să plătesc orice taxe inițial renunțate pe baza statutului meu educațional.',
        age: 'Confirm că am cel puțin 18 ani',
      },
      title: 'Termeni și condiții',
    },
  },
  toVerified: 'Obțineți verificarea educației',
  submitError: 'Trimiterea formularului a eşuat. Vă rugăm să încercați din nou mai târziu.',
  rejectContent: 'Din păcate, nu ești eligibil pentru statutul de Verificat Educațional și, prin urmare, nu poți primi cuponul exclusiv de 100% pentru Planul Profesional Dify dacă folosești această adresă de email.',
  successTitle: 'Ai obținut educația Dify verificată',
  learn: 'Învățați cum să verificați educația',
  submit: 'Trimite',
  emailLabel: 'Emailul tău curent',
  currentSigned: 'CONEXIUNE ÎN PREZENT CA',
  rejectTitle: 'Verificarea educațională Dify a fost respinsă',
  successContent: 'Am emis un cupon de discount de 100% pentru planul Professional Dify pe contul dumneavoastră. Cuponul este valabil timp de un an, vă rugăm să îl utilizați în perioada de valabilitate.',
}

export default translation
